import { resource } from "./resource";
import { invalidateOrgDepartments, getActiveLegalUnitId } from "./globalData";

const api = resource("/department");

// Writes drop the cached list here rather than at the call sites, so a screen
// that adds a department does not also have to know which dropdowns are
// reading a cached copy of it. Only on success: a rejected write left the
// server alone, so the cache is still right.
const invalidating = (res) => {
  if (res?.success !== false) invalidateOrgDepartments();
  return res;
};

export const getDepartmentByLegalUnit = async (legalUnit) =>
  await api.get(`/legal-unit/${legalUnit}`);

export const getDepartments = async () => await api.get("/organization");

/**
 * Departments for the entity being worked in, plus any belonging to the whole
 * organisation.
 *
 * getDepartmentByLegalUnit existed and nothing called it, so every picker took
 * the org-wide list. Default departments are created per entity, so an
 * organisation with two entities showed all 38 — every department twice.
 *
 * What ensureOrgDepartments caches. The cache key is org-wide and survives the
 * reload the entity switcher does, so setActiveLegalUnit drops it; otherwise
 * switching entity would keep showing the previous entity's departments until
 * the session ended.
 */
export const getDepartmentsForActiveEntity = async () => {
  const legalUnit = getActiveLegalUnitId();
  return legalUnit ? await getDepartmentByLegalUnit(legalUnit) : await getDepartments();
};

// { name, legalUnit }
export const createDepartment = async (input = {}) => invalidating(await api.post("", input));

// soft delete (PUT /department/delete/:id)
export const deleteDepartment = async (id) => invalidating(await api.put(`/delete/${id}`));
